// ServQual Brand Theme — derived from Brand Guidelines Sept 2024
export const brand = {
  colors: {
    primary: "#6BCE8B",
    primary1: "#6366f1",
    primaryDark: "#4FA96B",
    primaryLight: "#8EDBA6",
    primaryBg: "rgba(107, 206, 139, 0.08)",
    primaryBorder: "#CCCCCC",

    secondary: "#035EA5",
    secondaryDark: "#024A82",
    secondaryLight: "#0A7FDC",
    secondaryBg: "rgba(3, 94, 165, 0.08)",

    accent: "#FFFF00",
    accentMuted: "#E6E600",

    // Severity
    critical: "#FF4D6A",
    criticalBg: "rgba(255, 77, 106, 0.1)",
    high: "#FF8C42",
    highBg: "rgba(255, 140, 66, 0.1)",
    medium: "#FFD166",
    mediumBg: "rgba(255, 209, 102, 0.1)",
    low: "#6BCE8B",
    lowBg: "rgba(107, 206, 139, 0.1)",
    info: "#035EA5",
    infoBg: "rgba(3, 94, 165, 0.1)",

    // Neutrals
    background: "#fff",
    surface: "#fff",
    surfaceHover: "#e7e7e7",
    surfaceBorder: "#CCCCCC",
    cardBg: "#fff",
    text: "#212529",
    textSecondary: "#212529",
    textMuted: "#64748B",
    divider: "#21252908",
    divider1: "#CCCCCC",

    // Status
    success: "#6BCE8B",
    warning: "#FFD166",
    error: "#FF4D6A",
    queued: "#035EA5",
    running: "#0A7FDC",
    completed: "#6BCE8B",
    failed: "#FF4D6A",
    analyzed: "#8B5CF6",
  },
  font: "'Inter', 'Arial', sans-serif",
  radius: {
    sm: "6px",
    md: "10px",
    lg: "14px",
    xl: "20px",
  },
  shadow: {
    card: "0 2px 12px rgba(0, 0, 0, 0.3)",
    elevated: "0 8px 32px rgba(0, 0, 0, 0.4)",
    glow: "0 0 20px rgba(107, 206, 139, 0.15)",
  },
};
